import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { CareerApi } from '../../shared/nestjs/gd-only/services/career.api';
import { LoopBackConfig } from './../../shared/sdk/lb.config';

/*
  Generated class for the AvatarProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/

@Injectable()
export class AvatarProvider {

	empphotopath: any;
	loopbackPath: any;
	constructor(
		public storage: Storage,
		public careerApi: CareerApi
	) {

	}

	getAvatarUser(): Observable<any> {

		return Observable.create((observer) => {
			this.storage.get('SFGoAuth').then(result => {
				let SFGoAuth = JSON.parse(result);
				let empphotopath = SFGoAuth.empphotopath;
				let cocode = SFGoAuth.companyCode;
				let thePhoto = SFGoAuth.photo;
				if (empphotopath != null && empphotopath != undefined) {
					empphotopath += thePhoto;
					observer.next(empphotopath);
					observer.complete();
				} else {
					let loopbackPath: string = LoopBackConfig.getPath();
					empphotopath = loopbackPath + '/api/Storages/' + cocode + '/download/' + thePhoto;
					observer.next(empphotopath);
					observer.complete();
				}
			})
		})
	}

	getAvatarPath(): Observable<any> {
		return Observable.create((observer) => {
			this.storage.get('SFGoAuth').then(result => {
				let SFGoAuth = JSON.parse(result);
				let empphotopath = SFGoAuth.empphotopath;
				let cocode = SFGoAuth.companyCode;
				if (empphotopath != null && empphotopath != undefined) {
					observer.next(empphotopath);
					observer.complete();
				} else {
					let loopbackPath: string = LoopBackConfig.getPath();
					empphotopath = loopbackPath + '/api/Storages/' + cocode + '/download/';
					observer.next(empphotopath);
					observer.complete();
				}
			})
		})
	}

	getAttendancePicture(): Observable<any> {
		return Observable.create((observer) => {
			this.storage.get('SFGoAuth').then(result => {
				// let SFGoAuth = JSON.parse(result);
				let loopbackPath: string = LoopBackConfig.getPath();
				let empphotopath = loopbackPath + '/api/Storages/attendance/download/';
				observer.next(empphotopath);
				observer.complete();
			})
		})
	}

	getEmployeesPhoto(empId: any): Observable<any> {
		return Observable.create((observer) => {
			this.careerApi.getEmp({ empId: empId }).subscribe(
				result => {
					observer.next(result.data);
					observer.complete();
				}
			);
		})
	}

}



// WEBPACK FOOTER //
// ./src/providers/avatar/avatar.ts